var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pt-0 pb-0"},[_c('trev-job-reports-quick-links-bar')],1)],1),_c('v-row',[_c('v-col',[_c('trev-jobs-table',{attrs:{"isGlobal":true,"defaultStatus":''}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }